import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotInbox = ({
    spotColor = "#C9DBFE",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <g clipPath="url(#Spot=on,_Size=40_svg__a)">
            <path
                fill={spotColor}
                fillRule="evenodd"
                d="M21.5 8c3.35.756 9.372.966 13.25 4.766 3.878 3.811 6.665 10.498 4.485 14.332-2.192 3.823-9.43 3.368-15.735 4.902-6.317 1.545-11.769 3.665-15.58 1.95C4.123 32.237 2.065 28.113.93 23.343c-1.146-4.77-1.27-8.762-.157-12.1 1.1-3.337 3.462-6.01 6.148-6.89 2.698-.868 4.685-.12 7.08.647 1.953.834 4.14 2.233 7.5 3Z"
                clipRule="evenodd"
            />
            <path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
                d="M36.665 20h-10l-3.333 5h-6.667l-3.333-5h-10m33.333 0v10a3.333 3.333 0 0 1-3.333 3.334H6.665A3.333 3.333 0 0 1 3.332 30V20m33.333 0-5.75-11.483a3.334 3.334 0 0 0-2.983-1.85H12.065a3.334 3.334 0 0 0-2.983 1.85L3.332 20"
            />
        </g>
        <defs>
            <clipPath id="Spot=on,_Size=40_svg__a">
                <path fill="#fff" d="M0 0h40v40H0z" />
            </clipPath>
        </defs>
    </SVG>
);
SpotInbox.displayName = "SpotInbox";
